// extracted by mini-css-extract-plugin
export var copyableField = "_m0-4";
export var customerBadge = "_m0-0";
export var customerInfoTitle = "_m0-2";
export var details = "_m0-1";
export var dropdownContainer = "_m0-5";
export var dropdownImage = "_m0-6";
export var editAssigneeForm = "_m0-a";
export var editButton = "_m0-3";
export var email = "_m0-7";
export var hidden = "_m0-d";
export var input = "_m0-8";
export var saveButton = "_m0-b";
export var shopifyIcon = "_m0-c";
export var suggestionBadge = "_m0-e";
export var suggestionText = "_m0-f";
export var username = "_m0-9";